/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = KM
 *
 * 1 = MILES
 *
 * 2 = HOURS
 */
export enum MileageUnit {
  KM = 0,
  MILES = 1,
  HOURS = 2,
}
